<template>
	<div>

		<el-table class="qcTable" :data="scoreitemList" v-loading="loading">
			<el-table-column prop="Id" label="细则编号" min-width="100"></el-table-column>
			<el-table-column prop="Type" label="类型">
				<template slot-scope="scope">
					<span v-show="scope.row.Type == 1">
                                影像
                            </span>
					<span v-show="scope.row.Type == 2">
                                报告
                            </span>
							<span v-show="scope.row.Type == 3">
                                病史
                            </span>
					<span v-show="scope.row.Type == 0">
                                全部
                            </span>
				</template>
			</el-table-column>
			<el-table-column prop="Mode" label="模式">
				<template slot-scope="scope">
					<span v-show="scope.row.Mode == 1">
                                加分
                            </span>
					<span v-show="scope.row.Mode == 2">
                                减分
                            </span>
					<span v-show="scope.row.Mode == 0">
                                全部
                            </span>
				</template>
			</el-table-column>
			<el-table-column prop="ModalityType" label="设备">
				<template slot-scope="scope">
					{{scope.row.ModalityType}}
				</template>
			</el-table-column>
			<el-table-column prop="Description" min-width="300" label="描述"></el-table-column>
			<el-table-column prop="Enable" label="状态">
				<template slot-scope="scope">
					<span v-show="scope.row.Enable == 0">
                                禁用
                            </span>
					<span v-show="scope.row.Enable == 1">
                                启用
                            </span>
				</template>
			</el-table-column>
			<el-table-column prop="Score" label="分值"></el-table-column>
			<el-table-column prop="" label="操作" fixed="right" width="180">
				<template slot-scope="scope">
					<span class="table-task-btn detail" @click="showClick(scope.row)">编辑</span>
					<span class="table-task-btn delete" @click="delterClick(scope.row)">删除</span>
				</template>
			</el-table-column>

		</el-table>
	</div>
</template>

<script>
	import { mapState, mapActions, mapMutations } from 'vuex'
	export default {
		computed: {
			...Vuex.mapState('managerPlan', ['scoreitemList', 'scoreitemDeleteId', 'loading','rulesFrom'])
		},
		methods: {
			...Vuex.mapMutations('managerPlan', ['setRulesFrom', 'setSplitScreen']),
			...Vuex.mapActions('managerPlan', ['scoreitemDelete','GetDictionary']),
			//编辑
			showClick(datas) {
//				this.setSplitScreen(1);
				this.setRulesFrom(datas);
				let tag = 0;
				if (datas.Type == 1) {
					tag = 7;
				}else{
					tag = 6;
				}
				this.GetDictionary({
					tag:tag
				})
				this.$router.push("/home/plan/newRulesDetails");
			},

			//删除
			delterClick(arr) {
				this.scoreitemDeleteId.UniqueId = arr.ScoreItemGuid;
				this.$confirm('是否确定删除？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
				}).then(() => {
					this.scoreitemDelete();
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});

			}

		}

	}
</script>